import { Backdrop, CircularProgress, IconButton } from "@mui/material";
import React from "react";
import { createPortal } from "react-dom";
import { CSVLink } from "react-csv";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import type { Data } from "../types";
import { useTranslation } from "react-i18next";

export type CSVLoaderProps = {
  loading: boolean;
  data?: Data;
  resetData: () => void;
};

export const CSVLoader = ({
  loading,
  data,
  resetData,
}: React.PropsWithChildren<CSVLoaderProps>) => {
  const { t } = useTranslation();
  const isDataPresent = !!data;

  return (
    <>
      {createPortal(
        <Backdrop open={loading}>
          <CircularProgress />
        </Backdrop>,
        document.body,
        "csv-loader"
      )}
      <Dialog open={isDataPresent} onClose={resetData} fullWidth maxWidth="xs">
        <DialogTitle>
          {t("Export List to CSV")}
          <IconButton
            aria-label="close"
            onClick={resetData}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {isDataPresent && (
            <DialogContentText>
              {t("Your file is ready.") + " "}
              <CSVLink
                data={data.data}
                filename={data.filename}
                headers={data.headers}
                onClick={resetData}
                target="_self"
                style={{
                  color: "white",
                }}
              >
                {t("Click here")}
              </CSVLink>
              {" " + t("to download it.")}
            </DialogContentText>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
